import React from 'react'
import Singlepage from '../../Components/Workshops/Singlepage'
const Workshopsinglepage = () => {
  return (
    <><Singlepage/></>
    
  )
}

export default Workshopsinglepage